// extracted by mini-css-extract-plugin
export default {"menuTriggerNoHover":"src-signer-app-signer-experience-signer-toolbar-toolbar-menu-module__menuTriggerNoHover--2SmDM"};